import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { withSkipSpriGlobalLoader } from '@spri/services/loading';
import type { Navigation } from 'app/core/navigation/navigation.types';
import type { Observable } from 'rxjs';
import { ReplaySubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private httpClient = inject(HttpClient);
  private readonly navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

  public readonly navigation$: Observable<Navigation> = this.navigation.asObservable();

  /**
   * Get all navigation data
   */
  public get(): Observable<Navigation> {
    return this.httpClient.get<Navigation>('api/common/navigation', { context: withSkipSpriGlobalLoader() }).pipe(
      tap((navigation) => {
        this.navigation.next(navigation);
      })
    );
  }
}
